import { render, staticRenderFns } from "./customUpload.vue?vue&type=template&id=187bdbab&scoped=true"
import script from "./customUpload.vue?vue&type=script&lang=js"
export * from "./customUpload.vue?vue&type=script&lang=js"
import style0 from "./customUpload.vue?vue&type=style&index=0&id=187bdbab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187bdbab",
  null
  
)

export default component.exports